/**
 * @owner @Appboy/messaging-experience
 */

import { sparseSegmentRemoteLookupValidators } from "@schemas/remoteLookup/sparseSegmentRemoteLookupSchema";
import type {
  SparseSegmentRemoteLookupId,
  SparseSegmentRemoteLookupItem,
  SparseSegmentRemoteLookupFilters,
} from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const sparseSegmentProvider: RemoteLookupProvider<
  SparseSegmentRemoteLookupId,
  SparseSegmentRemoteLookupItem,
  SparseSegmentRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: {
    ...sparseSegmentRemoteLookupValidators,
    // non-strict typescript issue
    item: sparseSegmentRemoteLookupValidators.item as z.ZodType<SparseSegmentRemoteLookupItem>,
  },
};
